





















import Vue, { PropOptions } from 'vue';
import type { Testimonial } from '@/components/storyblok/TestimonialV2.vue';
import type { PaddingOptions } from '@/components/SectionContainer.vue';

export type Testimonials = Blok & {
  title: string;
  subTitle: string;
  testimonials: Testimonial[];
  paddingTop?: PaddingOptions;
  paddingBottom?: PaddingOptions;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Testimonials>,
  },
});
